// React
import { memo, useMemo } from 'react'

// Components
import { BaseImage, BaseImagePreview } from 'components'

// Styles
import styles from './index.module.scss'

// Antd
import { Button } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

// Interfaces
import { IBasePhotoUploaderProps } from './interfaces'

// Constant
import { FILE_IMAGE_EXTENSIONS } from 'constant/file.constant'

// Custom Hook
import { useUploader } from 'hooks'

const BasePhotoUploader = memo(({ image, onChange, error, maxDimensions, isOnlyMinimumDimensions }: IBasePhotoUploaderProps) => {
  // Hook
  const { t } = useTranslation()
  const { uploader_Input, uploader_onClickSingleFile } = useUploader({
    acceptedExtensions: FILE_IMAGE_EXTENSIONS,
    isOnlyMinimumDimensions: isOnlyMinimumDimensions === false ? false : true,
    maxDimensions,
  })
  const _isOnlyMinimumDimensions = useMemo((): boolean => {
    return isOnlyMinimumDimensions === false ? false : true
  }, [isOnlyMinimumDimensions])

  return (
    <>
      {/* Plain HTML Input File */}
      {uploader_Input(onChange)}

      <div className={styles['wrapper']}>
        {/* Render Image */}
        <div className={styles['image']}>
          {image ? (
            <BaseImagePreview>
              <a href={image}>
                <img src={image} alt={image} />
              </a>
            </BaseImagePreview>
          ) : (
            <BaseImage isImage image="back-office/image-big-empty" isError={Boolean(error)} />
          )}
        </div>
        {/* Button */}
        <div className={styles['button']}>
          <Button type="primary" block onClick={uploader_onClickSingleFile}>
            <div className="flex text-center justify-center items-center">
              <BaseImage isIcon isSvg icon="back-office/icon-pencil-edit-active" width="10.67px" height="13.33px" />

              <div className="ml-3">{t(`app.formPlaceholder.${image ? 'changeImage' : 'chooseImage'}`)}</div>
            </div>
          </Button>
        </div>

        {/* Footer */}
        <div className={styles['footer']}>
          {_isOnlyMinimumDimensions ? (
            <p>
              *
              {`${t(`app.validations.files.minimumWidth`)} ${maxDimensions?.width || 0}px ${t('app.and')} ${t(
                'app.validations.files.minimumHeight',
              )} ${maxDimensions?.height || 0}px`}
            </p>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  )
})

export { BasePhotoUploader }
